// extracted by mini-css-extract-plugin
export default {"container":"ProductDetailRelatedProducts-container-U26","border":"ProductDetailRelatedProducts-border-8iG","carousel":"ProductDetailRelatedProducts-carousel-aoB"};